(ns app.domain.periodic-inspection.model
  (:require [app.domain.group.config.model :as config-model]
            [app.domain.group.model :as group-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [core.db.entity.util :as eu]))

(def periodic-parent-states
  [:periodic-parent.state/open
   :periodic-parent.state/finished
   :periodic-parent.state/archived])


(defn workspace [periodic-parent]
  (-> periodic-parent :entity/parent))


(defmethod group-model/get-authority-group :entity.type/periodic-parent
  [periodic-parent]
  (-> periodic-parent workspace group-model/get-authority-group))


(defn work-type-name [periodic-parent lang]
  (some-> periodic-parent
          :entity/parent
          :workspace/work-type-group-configs
          first
          (config-model/localized-name lang)))


(defn work-target-name [periodic-parent lang]
  (some-> periodic-parent
          workspace
          :workspace/work-target-group-config
          (config-model/localized-name lang)))

(defn phase-periodic-parent-workspace [phase-entity]
  (if (eu/is-type? :entity.type/periodic-parent phase-entity)
    (:entity/parent phase-entity)
    (-> phase-entity ;; execution
        :entity/parent ;; periodic child workspace
        :workspace/parent-workspace)))

(defn phase-periodic-parent [phase-entity]
  (if (eu/is-type? :entity.type/periodic-parent phase-entity)
    phase-entity
    (-> phase-entity
        phase-periodic-parent-workspace
        workspace-model/workspace-periodic-parent)))

(defn child-workspace?
  "True for an inspection round workspace, i.e. a workspace that belongs to a periodic parent
  workspace. `:workspace/parent-workspace` is only ever set for periodic inspections."
  [workspace]
  (some? (:workspace/parent-workspace workspace)))

(defn child-workspaces
  "The inspection round workspaces of a periodic parent `workspace`."
  [workspace]
  (:workspace/_parent-workspace workspace))

(defn periodic-inspection-workspace-in-finished-state? [workspace]
  (some->> workspace
           workspace-model/workspace-execution
           ((du/in-state-fn :execution.state/complete :execution.state/closed))))
